import { useServices, useSave } from '@/ui/services/ServicesContext';
import { useI18n } from '@/ui/i18n/I18nProvider';
import styles from './MiniGameOverlay.module.css';

/**
 * Sổ công thức của bà (minigames.md §4.11): one page per dish cooked, with Granny's notes found so far.
 * Shown inside the Bếp của bà intro card.
 */
export function RecipeBook({ onClose }: { onClose: () => void }) {
  const { t } = useI18n();
  const { content } = useServices();
  const def = content.miniGames.get('mg_cooking');
  const cleared = useSave((s) => s.miniGames.mg_cooking?.levelsCleared.join(',') ?? '');
  const seen = useSave((s) => s.miniGames.mg_cooking?.seenNoteKeys.join('|') ?? '');
  if (!def) return null;
  const done = new Set(cleared === '' ? [] : cleared.split(',').map(Number));
  const notes = new Set(seen === '' ? [] : seen.split('|'));

  return (
    <section className={styles.book} aria-labelledby="recipe-book-title" data-testid="recipe-book">
      <h3 id="recipe-book-title" className={styles.levelName}>
        {t('ui.cooking.recipe_book_title')}
      </h3>
      <ol className={styles.bookPages}>
        {def.levels.map((l) => {
          const found = l.noteKeys.filter((k) => notes.has(k));
          return (
            <li key={l.level} data-cooked={done.has(l.level)}>
              <strong>{t(l.nameKey)}</strong>
              {done.has(l.level) ? (
                <>
                  <span className={styles.muted}>
                    {t('ui.cooking.recipe_notes', { count: found.length, total: l.noteKeys.length })}
                  </span>
                  {found.map((k) => (
                    <q key={k} className={styles.note}>
                      {t(k)}
                    </q>
                  ))}
                </>
              ) : (
                <span className={styles.muted}>{t('ui.cooking.recipe_locked')}</span>
              )}
            </li>
          );
        })}
      </ol>
      <button type="button" className={styles.secondary} onClick={onClose}>
        {t('ui.cooking.recipe_book_close')}
      </button>
    </section>
  );
}
